export const GET_FAQ_LIST = 'FAQ/get_faq';
export const GET_SINGLE_FAQ = 'FAQ/GET_SINGLE_FAQ';
export const UPDATE_FAQ = 'FAQ/update_faq';
export const CREATE_FAQ = 'FAQ/create_faq';
export const REMOVE_FAQ = 'FAQ/remove_faq';

export const FORM_DATA = {
  title_en: '',
  title_tl: '',
  sequence: '',
  description_en: '',
  description_tl: '',
  is_active: '',
};
